<div class="modal inmodal fade in show">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row">
                        <h4 class="modal-title col-sm-8">New User Role</h4>

                        <div class="input-group-btn pull-right">
                            <button class="btn btn-primary submit" type="submit" [disabled]="disabledSubmit">
                                Save
                            </button>

                            <button data-toggle="dropdown"
                                    class="btn btn-primary dropdown-toggle" type="button" aria-expanded="false">
                                <span class="caret"></span>
                            </button>

                            <ul class="dropdown-menu pull-right">
                                <li><a (click)="close(form)">Cancel</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="modal-body standard-input-field-height">
                    <input-field name="name" [required]="true" [title]="'User Role Name'" [editOnly]="true" ngModel>
                    </input-field>
                </div>
                <div class="modal-body bottom-block">
                    <div class="row m-b-xs">
                            <div class="dv-label col-sm-3 strong m-t-xs">Corp. #</div>
                            <div class="dv-value col-sm-9">
                                <search-select ngModel name="corporationNumberId"
                                               [data]="corporationsToSearchSelect(userRoleService.corporationNumberList)">
                                </search-select>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="modal-backdrop fade in" (click)="close(form)"></div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/create-modal/create-modal.component.html